/**
 * Company Profile Service
 * HTTP operations for company detail/profile
 */

import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import type { LC_GetCompanyByIdOut, CompanyProfile } from '../types/companyProfile.types';
import { mapCompanyByIdOutToProfile } from '../mappers/companyProfile.mapper';

/**
 * Service class for company profile operations
 */
export class CompanyProfileService {
  /**
   * Get company by ID
   * GET /v{version}/Company/{companyId}
   */
  async getById(companyId: number): Promise<ApiResponse<CompanyProfile>> {
    const endpoint = API_CONFIG.ENDPOINTS.COMPANY.GET_BY_ID(companyId);

    const response = await apiClient.get<LC_GetCompanyByIdOut>(endpoint);

    if (!response.success || !response.data) {
      return {
        success: response.success,
        error: response.error,
        data: null,
      };
    }

    return {
      ...response,
      data: mapCompanyByIdOutToProfile(response.data),
    };
  }
}

export const companyProfileService = new CompanyProfileService();
